import { Icon, TooltipHost } from '@fluentui/react';
import { t } from 'i18next';

export default function InfoHourDecimalTooltip() {
  return (
    <TooltipHost content={t("Horas expresadas en formato decimal.")}>
      <Icon
        iconName="Info"
        styles={{ root: { fontSize: '12px', marginLeft: '4px', color: '#888' } }}
        style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}
      />
    </TooltipHost>
  );
}
